// Marker attribute placed on selectable data cells (see Cell.tsx). The value
// is a per-table scope id (from useId()) that identifies which table owns the
// cell. A mousedown whose target's closest selectable ancestor carries a
// different scope id (or none) is treated as "outside this table's cells" and
// clears that table's selection.
export const CELL_SELECTABLE_ATTRIBUTE = 'data-fdt-cell-selectable';
export const CELL_SELECTED_ATTRIBUTE = 'data-fdt-cell-selected';
export const FILL_HANDLE_ATTRIBUTE = 'data-fdt-fill-handle';

// Which outer edges of the selection region this cell sits on. An empty string
// means the cell is interior (no edges). null means not selected at all.
// Values are substrings of "trbl" (top/right/bottom/left).
export const CELL_EDGES_ATTRIBUTE = 'data-fdt-cell-edges';